import React, {Component} from 'react';

import {getMedia} from './fetch/fetchApi';
import Preloader from './Preloader'
import './ProductImage.css';

class ProductImage extends Component {
  constructor(props) {
    super(props);

    this.fullscreen = this.fullscreen.bind(this);
    this.fullCheck = this.fullCheck.bind(this);
    this.handleImageLoaded = this.handleImageLoaded.bind(this);

    this.state = {
      imgs: [],
      fullscreen: {
        full: false,
        img: {}
      },
      imagesLoaded: false,
      imageLoadedCount: 0
    }
  }

  componentWillMount() {
    if ( this.state.imgs.length === 0 ) {
      console.log(this.props.imgData)
      const imgs = getMedia(this.props.imgData);
      imgs.then((img) => {
        console.log(img)
        this.setState({imgs: img});
      });
    }
  }

  handleImageLoaded(image) {
    if(this.state.imgs.length - 1 === this.state.imageLoadedCount) {
      setTimeout(function() { this.setState({imagesLoaded: true}); }.bind(this), 300);
      
    } else {
      this.setState({imageLoadedCount: this.state.imageLoadedCount + 1});
    }
  }

  fullscreen(e, image) {
    e.preventDefault();
    this.setState({fullscreen: {
      full: !this.state.fullscreen.full,
      img: image
      }
    });
  }

  fullCheck(image, portraitClass) {
    if(this.state.fullscreen.full && image !== this.state.fullscreen.img) {
     return 'hide ' + portraitClass;
    } else if(this.state.fullscreen.full) {
      return 'small-12 columns fullscreen ' + portraitClass;
    } else {
      return 'small-12 large-4 columns ' + portraitClass;
    }
  }

  render() {
    const _this = this;
    let portraitClass = '';
    const imgs = this.state.imgs.map(function(image, index) {
      let url;
      if (image.media_details.sizes.large) {
        url = image.media_details.sizes.large.source_url;
      } else {
        url = image.media_details.sizes.full.source_url;
      }
      if(image.media_details.height > image.media_details.width) {
        portraitClass = 'isPortrait';
      } else {
        portraitClass = '';
      }
      return (
        <div key={image.id}  className={_this.fullCheck(image, portraitClass)}>
          <a href="#" className="product-image" onClick={(e) => {_this.fullscreen(e, image)}}>
            <img onLoad={_this.handleImageLoaded.bind(this, image)} src={url} alt={image.alt_text} />
          </a>
        </div>
      )
    })
    return (
      <div className="row collapse expanded ProductImage-row">
        <Preloader preloader={!_this.state.imagesLoaded}  />
        {imgs}
      </div>
    )
  }
}

ProductImage.propTypes = {  
};

export default ProductImage;





// WEBPACK FOOTER //
// ./src/components/ProductImage.js